import api from '../config/api';

/**
 * BOM Service — API calls for the production BOM + Work Order module.
 * Backend routes mounted at /api/boms (backend/bom-management/routes.js).
 *
 * Built 2026-05-29, session 0a78368c. Task #36.
 */
class BomService {
  // --- BOMs ---
  async listBoms(brandId, params = {}) {
    const response = await api.get(`/api/boms/brands/${brandId}/boms`, { params });
    return response.data;
  }

  async drillBom(brandId, assemblySku, params = {}) {
    const response = await api.get(
      `/api/boms/brands/${brandId}/boms/${encodeURIComponent(assemblySku)}`,
      { params }
    );
    return response.data;
  }

  async getBuildability(brandId, params = {}) {
    const response = await api.get(`/api/boms/brands/${brandId}/buildability`, { params });
    return response.data;
  }

  // --- Production BOM authoring ---
  async getUomOptions() {
    const response = await api.get(`/api/boms/uom-options`);
    return response.data;
  }

  async createProductionBom(brandId, payload) {
    const response = await api.post(`/api/boms/brands/${brandId}/production-boms`, payload);
    return response.data;
  }

  async updateProductionBom(brandId, assemblySku, payload) {
    const response = await api.put(
      `/api/boms/brands/${brandId}/production-boms/${encodeURIComponent(assemblySku)}`, payload
    );
    return response.data;
  }

  async deleteProductionBom(brandId, assemblySku) {
    const response = await api.delete(
      `/api/boms/brands/${brandId}/production-boms/${encodeURIComponent(assemblySku)}`
    );
    return response.data;
  }

  // --- Work Orders ---
  async listWorkOrders(brandId, params = {}) {
    const response = await api.get(`/api/boms/brands/${brandId}/work-orders`, { params });
    return response.data;
  }

  async drillWorkOrder(brandId, woId, params = {}) {
    const response = await api.get(`/api/boms/brands/${brandId}/work-orders/${woId}`, { params });
    return response.data;
  }

  async listAssemblyBuilds(brandId, params = {}) {
    const response = await api.get(`/api/boms/brands/${brandId}/assembly-builds`, { params });
    return response.data;
  }

  // --- Admin: CIN7 unresolved bucket ---
  async listUnresolvedBoms(params = {}) {
    const response = await api.get(`/api/boms/admin/unresolved/cin7-boms`, { params });
    return response.data;
  }

  async listUnresolvedJobs(params = {}) {
    const response = await api.get(`/api/boms/admin/unresolved/cin7-jobs`, { params });
    return response.data;
  }

  async resolveUnresolvedBom(cin7BomId, note = '') {
    const response = await api.post(
      `/api/boms/admin/unresolved/cin7-boms/${cin7BomId}/resolve`, { note }
    );
    return response.data;
  }

  async resolveUnresolvedJob(cin7JobId, note = '') {
    const response = await api.post(
      `/api/boms/admin/unresolved/cin7-jobs/${cin7JobId}/resolve`, { note }
    );
    return response.data;
  }
}

export default new BomService();
